import { NeuButton } from '@hcahealthcaredpx/neutron-react';

import styles from '../profile.module.css';
import { ProviderLocation } from '../profile.types';

export const CallFacilityButton = ({ location }: { location: ProviderLocation }): JSX.Element => (
  <div className={styles.addressButton}>
    <NeuButton
      key={location.id}
      className="w-100"
      icon="call"
      onClick={() =>
        window.open(`tel:${location.phone || location.relatedContactCenterPhoneNumber}`, '_self')
      }
    >
      <div className="sr-only">Call to </div>
      {location.phone ? location.phone : location.relatedContactCenterPhoneNumber}
      <div className="sr-only"> phone</div>
    </NeuButton>
  </div>
);
